<template>
  <v-container id="data-tables" tag="section">
    <base-material-card
      color="grey darken-3"
      icon="mdi-account-child"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("Children") }}
        </div>
      </template>
      <div class="text-right">
        <v-btn
          class="ma-1"
          color="primary"
          @click="$router.push({ name: 'child.create' })"
        >
          {{ $t("create") }}
        </v-btn>
      </div>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="ml-auto"
        :label="$t('search')"
        hide-details
        single-line
        style="max-width: 250px;"
      />
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="true"
        class="elevation-1"
      >
        <template v-slot:item.parents="{ item }">
          <a
            v-for="(parent, index) in item.parents"
            @click="$router.push({ path: '/be/person/' + parent.id + '/show' })"
            :key="index"
            >{{ parent.first_name }} {{ parent.last_name }} ({{ parent.place }})
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template></v-data-table
      >
      <v-divider class="mt-3" />
    </base-material-card>
  </v-container>
</template>

<script>
import { fetchItems, deleteItem } from "../shared/services";

export default {
  name: "app-child-list",
  data() {
    return {
      loading: true,
      options: {},
      total: 0,
      search: "",
      items: [],
      currentRequestId: 0,
    };
  },

  created() {
    this.getData();
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("first_name"),
          align: "left",
          value: "first_name"
        },
        {
          text: this.$t("last_name"),
          align: "left",
          value: "last_name"
        },
        {
          text: this.$t("People"),
          align: "left",
          value: "parents"
        },
        {
          text: this.$t("tax"),
          align: "left",
          value: "tax"
        },
        { text: "", value: "action", sortable: false }
      ];
    }
  },
  methods: {
    async getData() {
      this.currentRequestId++;
      const requestId = this.currentRequestId;

      this.loading = true;
      let response = await fetchItems({ ...this.options, search: this.search });
      if (requestId === this.currentRequestId) { 
        this.items = response.data;
        this.total = response.meta.total;
        this.loading = false;
      }
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Child?")
        )
      ) {
        let resp = await deleteItem(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    editItem(item) {
      let url = item.id;
      this.$router.push({ name: "child.edit", params: { id: url } });
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler: _.debounce(function () {
        this.getData();
      }, 300), // 300ms debounce delay
      immediate: false,
    },
  }
};
</script>

<style lang="scss" scoped></style>
